export default __webpack_public_path__ + "static/media/ca-ES.90554f20.svg";